import React, { useContext } from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ModalContext from 'react-bootstrap/ModalContext';

export const FormModalFooter = () => {
  const { t } = useTranslation();
  const { onHide } = useContext(ModalContext);

  return (
    <Modal.Footer className="pt-0">
      <Button type="button" variant="outline-primary" onClick={onHide}>
        {t('Cancel')}
      </Button>

      <Button type="submit" variant="primary">
        {t('Save')}
      </Button>
    </Modal.Footer>
  );
};
